module.exports = __webpack_public_path__ + "img/vertical_1_1_6000.043bf3a7.png";